import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import { useGetShipmentDetails } from "api/queries/shipments/useGetShipmentDetails";
import IntermediateInvoiceDialog from "./IntermediateInvoiceDialog";

export default function ProviderTrackingActionButtons() {
  const id = useParams().id?.toUpperCase();
  const [showIntermediateInvoiceDialog, setShowIntermediateInvoiceDialog] = useState(false);
  const { data: shipmentDetailsData } = useGetShipmentDetails(id!, true, {
    enabled: !!id,
    refetchOnMount: false,
  });

  const isShipping = ["Delayed", "In transit", "Booked"].includes(shipmentDetailsData?.organization?.shipment_status);
  const allowIntermediateInvoice = isShipping && shipmentDetailsData?.financial?.can_submit_intermediate_invoice;

  return (
    <>
      <IntermediateInvoiceDialog
        isOpen={showIntermediateInvoiceDialog}
        close={() => setShowIntermediateInvoiceDialog(false)}
      />
      {allowIntermediateInvoice && (
        <button type="button" className="cta-button gray" onClick={() => setShowIntermediateInvoiceDialog(true)}>
          <FormattedMessage id="components.molecules.navigation.intermediateInvoice" defaultMessage="Intermediate invoice" />
        </button>
      )}
    </>
  );
}
